import {gql} from "@apollo/client";

export const CONFIRM_ACCESS = gql`
    mutation ConfirmAccess($token: String!) {
        confirmAccess(token: $token, type: EMAIL)
    }
`;
